module.exports = __webpack_public_path__ + "static/media/sandwichbarmenu.d3f891fc.jpeg";